module.exports = __webpack_public_path__ + "img/lighthouseTrophy.5ee622ec.jpg";